/**
 * Değerlendirme (v0.1.260, specs/degerlendirme.md): GET /evals/temsilci shows the Temsilci's reply evaluation, the
 * newest runs with their score and the newest run's cases (outcome, the checks that failed, the draft as it would be
 * sent). The cases are made-up rewrites of customer mails (config/evals/temsilci.json); no buyer data.
 */
import { z } from 'zod';
import { countSchema } from '../ids.js';
export const EVAL_OUTCOMES = ['passed', 'failed', 'skipped', 'error'];
export const EVAL_RUN_STATUSES = ['running', 'completed', 'failed'];
export const evalRunSchema = z.strictObject({
    id: z.string(),
    status: z.enum(EVAL_RUN_STATUSES),
    suiteVersion: z.number().int().positive(),
    model: z.string().nullable(),
    cases: countSchema,
    passed: countSchema,
    skipped: countSchema,
    errors: countSchema,
    costUsd: z.number().min(0),
    startedAt: z.number(),
    finishedAt: z.number().nullable(),
    note: z.string().nullable(),
});
export const evalCaseResultSchema = z.strictObject({
    caseId: z.string(),
    outcome: z.enum(EVAL_OUTCOMES),
    failures: z.array(z.strictObject({ id: z.string(), whyTr: z.string() })),
    draft: z.string().nullable(),
    words: z.number().int().min(0).nullable(),
    /** The outcome of the same case in the run before, when there is one. */
    previous: z.enum(EVAL_OUTCOMES).nullable(),
});
export const evalViewSchema = z.strictObject({
    asOf: z.number(),
    suite: z.enum(['temsilci', 'asistan']),
    /** Newest first, at most 12. */
    runs: z.array(evalRunSchema),
    /** The newest completed run's cases, failures first. */
    results: z.array(evalCaseResultSchema),
});
//# sourceMappingURL=evals.js.map